import { dayjs } from './dayjs';

export function convertUnixMsToDate(timestamp: string, format: string = 'M/D/YYYY') {
	return dayjs.utc(timestamp, 'x').format(format);
}

export function buildDateFilters(op: string, value: string) {
	const timezone = 'UTC'; // Default since the invoices span multiple facilities

	const startOfDay = dayjs.tz(value, 'YYYY-MM-DD', timezone).startOf('day').format();
	const endOfDay = dayjs.tz(value, 'YYYY-MM-DD', timezone).endOf('day').format();

	switch (op) {
		case 'EQ':
		case 'NE': {
			return [
				{
					op: op === 'EQ' ? 'GTE' : 'LTE',
					value: startOfDay,
				},
				{
					op: op === 'EQ' ? 'LTE' : 'GTE',
					value: endOfDay,
				},
			];
		}
		case 'GT':
		case 'LTE':
			return [
				{
					op,
					value: endOfDay,
				},
			];
		case 'GTE':
		case 'LT':
			return [
				{
					op,
					value: startOfDay,
				},
			];
		default:
			return [
				{
					op,
					value,
				},
			];
	}
}
